/* @ngInject */
const resource = (
  $resource,
  paths
) => {
  const path = `${paths.handlers.email}/:action`

  return $resource(
    path,
    { action: '@action' }, {
    'update': {
      method: 'PUT',
    },
    'query': {
      method: 'GET',
    },
    'get': {
      method: 'GET',
      isArray: false,
    },
  }
  )
}

export default resource



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/email/services/resource.service.js